// Liste des pays avec dial code + flag emoji.
// Ordre : Afrique de l'Ouest francophone en premier (cœur de cible), puis Afrique, Europe, Monde.

export interface Country {
  code: string; // ISO 3166-1 alpha-2
  name: string;
  dial: string; // ex: "221" (sans le +)
  flag: string; // emoji
}

export const COUNTRIES: Country[] = [
  // Afrique de l'Ouest francophone (cible principale)
  { code: "SN", name: "Sénégal", dial: "221", flag: "🇸🇳" },
  { code: "CI", name: "Côte d'Ivoire", dial: "225", flag: "🇨🇮" },
  { code: "ML", name: "Mali", dial: "223", flag: "🇲🇱" },
  { code: "BF", name: "Burkina Faso", dial: "226", flag: "🇧🇫" },
  { code: "GN", name: "Guinée", dial: "224", flag: "🇬🇳" },
  { code: "NE", name: "Niger", dial: "227", flag: "🇳🇪" },
  { code: "TG", name: "Togo", dial: "228", flag: "🇹🇬" },
  { code: "BJ", name: "Bénin", dial: "229", flag: "🇧🇯" },
  { code: "GW", name: "Guinée-Bissau", dial: "245", flag: "🇬🇼" },
  { code: "MR", name: "Mauritanie", dial: "222", flag: "🇲🇷" },
  { code: "CV", name: "Cap-Vert", dial: "238", flag: "🇨🇻" },
  { code: "GM", name: "Gambie", dial: "220", flag: "🇬🇲" },

  // Afrique centrale
  { code: "CM", name: "Cameroun", dial: "237", flag: "🇨🇲" },
  { code: "GA", name: "Gabon", dial: "241", flag: "🇬🇦" },
  { code: "CG", name: "Congo", dial: "242", flag: "🇨🇬" },
  { code: "CD", name: "RD Congo", dial: "243", flag: "🇨🇩" },
  { code: "CF", name: "Centrafrique", dial: "236", flag: "🇨🇫" },
  { code: "TD", name: "Tchad", dial: "235", flag: "🇹🇩" },

  // Maghreb
  { code: "MA", name: "Maroc", dial: "212", flag: "🇲🇦" },
  { code: "DZ", name: "Algérie", dial: "213", flag: "🇩🇿" },
  { code: "TN", name: "Tunisie", dial: "216", flag: "🇹🇳" },
  { code: "LY", name: "Libye", dial: "218", flag: "🇱🇾" },
  { code: "EG", name: "Égypte", dial: "20", flag: "🇪🇬" },

  // Afrique anglophone & autres
  { code: "NG", name: "Nigeria", dial: "234", flag: "🇳🇬" },
  { code: "GH", name: "Ghana", dial: "233", flag: "🇬🇭" },
  { code: "KE", name: "Kenya", dial: "254", flag: "🇰🇪" },
  { code: "ZA", name: "Afrique du Sud", dial: "27", flag: "🇿🇦" },
  { code: "ET", name: "Éthiopie", dial: "251", flag: "🇪🇹" },
  { code: "UG", name: "Ouganda", dial: "256", flag: "🇺🇬" },
  { code: "TZ", name: "Tanzanie", dial: "255", flag: "🇹🇿" },
  { code: "RW", name: "Rwanda", dial: "250", flag: "🇷🇼" },
  { code: "MG", name: "Madagascar", dial: "261", flag: "🇲🇬" },
  { code: "AO", name: "Angola", dial: "244", flag: "🇦🇴" },
  { code: "MZ", name: "Mozambique", dial: "258", flag: "🇲🇿" },
  { code: "ZM", name: "Zambie", dial: "260", flag: "🇿🇲" },
  { code: "ZW", name: "Zimbabwe", dial: "263", flag: "🇿🇼" },
  { code: "SL", name: "Sierra Leone", dial: "232", flag: "🇸🇱" },
  { code: "LR", name: "Liberia", dial: "231", flag: "🇱🇷" },

  // Europe (diaspora)
  { code: "FR", name: "France", dial: "33", flag: "🇫🇷" },
  { code: "BE", name: "Belgique", dial: "32", flag: "🇧🇪" },
  { code: "CH", name: "Suisse", dial: "41", flag: "🇨🇭" },
  { code: "DE", name: "Allemagne", dial: "49", flag: "🇩🇪" },
  { code: "IT", name: "Italie", dial: "39", flag: "🇮🇹" },
  { code: "ES", name: "Espagne", dial: "34", flag: "🇪🇸" },
  { code: "PT", name: "Portugal", dial: "351", flag: "🇵🇹" },
  { code: "NL", name: "Pays-Bas", dial: "31", flag: "🇳🇱" },
  { code: "GB", name: "Royaume-Uni", dial: "44", flag: "🇬🇧" },
  { code: "IE", name: "Irlande", dial: "353", flag: "🇮🇪" },
  { code: "SE", name: "Suède", dial: "46", flag: "🇸🇪" },
  { code: "NO", name: "Norvège", dial: "47", flag: "🇳🇴" },
  { code: "DK", name: "Danemark", dial: "45", flag: "🇩🇰" },
  { code: "FI", name: "Finlande", dial: "358", flag: "🇫🇮" },
  { code: "PL", name: "Pologne", dial: "48", flag: "🇵🇱" },
  { code: "AT", name: "Autriche", dial: "43", flag: "🇦🇹" },
  { code: "GR", name: "Grèce", dial: "30", flag: "🇬🇷" },
  { code: "RO", name: "Roumanie", dial: "40", flag: "🇷🇴" },

  // Moyen-Orient
  { code: "AE", name: "Émirats arabes unis", dial: "971", flag: "🇦🇪" },
  { code: "SA", name: "Arabie saoudite", dial: "966", flag: "🇸🇦" },
  { code: "QA", name: "Qatar", dial: "974", flag: "🇶🇦" },
  { code: "KW", name: "Koweït", dial: "965", flag: "🇰🇼" },
  { code: "TR", name: "Turquie", dial: "90", flag: "🇹🇷" },
  { code: "IL", name: "Israël", dial: "972", flag: "🇮🇱" },
  { code: "LB", name: "Liban", dial: "961", flag: "🇱🇧" },

  // Amériques
  { code: "US", name: "États-Unis", dial: "1", flag: "🇺🇸" },
  { code: "CA", name: "Canada", dial: "1", flag: "🇨🇦" },
  { code: "BR", name: "Brésil", dial: "55", flag: "🇧🇷" },
  { code: "MX", name: "Mexique", dial: "52", flag: "🇲🇽" },
  { code: "AR", name: "Argentine", dial: "54", flag: "🇦🇷" },
  { code: "CL", name: "Chili", dial: "56", flag: "🇨🇱" },
  { code: "CO", name: "Colombie", dial: "57", flag: "🇨🇴" },

  // Asie
  { code: "CN", name: "Chine", dial: "86", flag: "🇨🇳" },
  { code: "IN", name: "Inde", dial: "91", flag: "🇮🇳" },
  { code: "JP", name: "Japon", dial: "81", flag: "🇯🇵" },
  { code: "KR", name: "Corée du Sud", dial: "82", flag: "🇰🇷" },
  { code: "ID", name: "Indonésie", dial: "62", flag: "🇮🇩" },
  { code: "PK", name: "Pakistan", dial: "92", flag: "🇵🇰" },
  { code: "BD", name: "Bangladesh", dial: "880", flag: "🇧🇩" },
  { code: "PH", name: "Philippines", dial: "63", flag: "🇵🇭" },
  { code: "TH", name: "Thaïlande", dial: "66", flag: "🇹🇭" },
  { code: "VN", name: "Vietnam", dial: "84", flag: "🇻🇳" },
  { code: "MY", name: "Malaisie", dial: "60", flag: "🇲🇾" },
  { code: "SG", name: "Singapour", dial: "65", flag: "🇸🇬" },

  // Océanie
  { code: "AU", name: "Australie", dial: "61", flag: "🇦🇺" },
  { code: "NZ", name: "Nouvelle-Zélande", dial: "64", flag: "🇳🇿" },
];

export const DEFAULT_COUNTRY: Country = COUNTRIES[0]; // Sénégal

export function findCountryByDial(dial: string): Country | undefined {
  return COUNTRIES.find((c) => c.dial === dial);
}

export function findCountryByCode(code: string): Country | undefined {
  return COUNTRIES.find((c) => c.code === code);
}

/**
 * Parse un numéro E.164 (+221771234567) ou local en { country, local }.
 * Si le préfixe n'est pas reconnu, retourne le défaut.
 */
export function parsePhone(input: string | null | undefined): { country: Country; local: string } {
  if (!input) return { country: DEFAULT_COUNTRY, local: "" };
  const cleaned = input.replace(/[^\d+]/g, "");
  if (cleaned.startsWith("+")) {
    const digits = cleaned.slice(1);
    // Essaye les codes les plus longs en premier (max 4 chiffres)
    for (let len = 4; len >= 1; len--) {
      const prefix = digits.slice(0, len);
      const c = findCountryByDial(prefix);
      if (c) return { country: c, local: digits.slice(len) };
    }
  }
  return { country: DEFAULT_COUNTRY, local: cleaned };
}

/** Assemble un numéro E.164 à partir d'un pays et d'une partie locale. */
export function toE164(country: Country, local: string): string {
  const digits = local.replace(/\D/g, "");
  return `+${country.dial}${digits}`;
}
